import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { X, ArrowUpRight } from "lucide-react";
import GeoMark from "./GeoMark";
import { NAV_LINKS, COMPANY } from "../data/content";
import { EASE } from "../lib/motion";

const MobileMenu = ({ open, onClose }) => (
  <AnimatePresence>
    {open && (
      <motion.div
        data-testid="mobile-menu"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.4, ease: EASE }}
        className="fixed inset-0 z-[80] bg-paper/90 backdrop-blur-2xl text-coal flex flex-col"
        role="dialog"
        aria-modal="true"
        aria-label="Menu"
      >
        <div className="container-ax flex items-center justify-between h-[68px] border-b border-ink/10">
          <div className="flex items-center gap-3">
            <GeoMark size={28} />
            <span className="text-[15px] font-bold tracking-[0.18em]">ARCH EXPO</span>
          </div>
          <button data-testid="mobile-menu-close" onClick={onClose} aria-label="Close menu" className="p-2.5 rounded-full bg-white/60 text-coal hover:bg-white/80 transition-colors">
            <X size={24} />
          </button>
        </div>
        <nav className="flex-1 flex flex-col justify-center container-ax" aria-label="Mobile">
          {[{ label: "Home", to: "/" }, ...NAV_LINKS].map((l, i) => (
            <div key={l.to} className="mask-line border-b border-ink/10">
              <motion.div
                initial={{ y: "110%" }}
                animate={{ y: "0%" }}
                exit={{ y: "110%" }}
                transition={{ type: "spring", stiffness: 120, damping: 18, delay: 0.08 + i * 0.06 }}
              >
                <Link
                  to={l.to}
                  data-testid={`mobile-nav-${l.label.toLowerCase()}`}
                  onClick={onClose}
                  className="group flex items-baseline justify-between py-4 sm:py-5"
                >
                  <span className="flex items-baseline gap-4">
                    <span className="label-tech text-cobalt">{String(i + 1).padStart(2, "0")}</span>
                    <span className="text-4xl sm:text-5xl font-semibold tracking-[-0.02em] group-hover:text-steel transition-colors duration-300">
                      {l.label}
                    </span>
                  </span>
                  <ArrowUpRight size={26} className="text-ink/25 group-hover:text-steel group-hover:translate-x-1 group-hover:-translate-y-1 transition-all duration-300" />
                </Link>
              </motion.div>
            </div>
          ))}
        </nav>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, ease: EASE, delay: 0.5 }}
          className="container-ax pb-10 flex flex-wrap gap-x-10 gap-y-3 text-sm text-graphite"
        >
          <a href={`mailto:${COMPANY.email}`} className="hover:text-coal transition-colors">{COMPANY.email}</a>
        </motion.div>
      </motion.div>
    )}
  </AnimatePresence>
);

export default MobileMenu;
